import { useEffect } from 'react';

import {
  changePassword,
  clearChangePasswordError,
  clearIsChangePasswordSuccess,
  useSelectChangePasswordError,
  useSelectIsChangePasswordSuccess
} from 'Auth/data';
import { useAppDispatch } from 'Store';

import type { IChangePasswordRequest } from '@libs/models';

import { ChangePasswordForm } from './ChangePasswordForm';

type Props = {
  onClose: () => void;
};

export const ChangePasswordFormContainer = ({ onClose }: Readonly<Props>) => {
  const dispatch = useAppDispatch();

  const changePasswordError = useSelectChangePasswordError();
  const isChangePasswordSuccess = useSelectIsChangePasswordSuccess();

  const handleSubmit = (values: IChangePasswordRequest) => {
    dispatch(changePassword(values));
  };

  useEffect(() => {
    dispatch(clearChangePasswordError());
    dispatch(clearIsChangePasswordSuccess());
  }, [dispatch]);

  return (
    <ChangePasswordForm
      onSubmit={handleSubmit}
      onCancel={onClose}
      error={changePasswordError as string | null}
      isSubmitSuccess={isChangePasswordSuccess as boolean}
    />
  );
};
